import { useCallback, useEffect } from 'react'

const HEADER_OFFSET = 99

export const useScrollWithOffset: () => void = () => {
  const windowService: () => Window | {} = useCallback(
    () => (typeof window !== 'undefined' ? window : {}),
    []
  )

  useEffect(() => {
    const _window = windowService()
    if (!(_window instanceof Window)) return

    _window.setTimeout(() => {
      const key = _window.location.href.split('#')[1]

      const element = document && document.getElementById(key)
      if (!element) return

      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + _window.scrollY - HEADER_OFFSET
      
      _window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }, 300);
  }, [])
}
